import React, { useEffect, useState, useCallback } from 'react';
import ReactQuill from 'react-quill';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import H3Text from '@Uilib/h3Text';
import debounce from 'lodash.debounce';

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    maxHeight: '70dvh',
    overflow: 'auto',
  },
};

const ProductDescriptions = ({ descriptions, onChange, modules }) => {
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [localValue, setLocalValue] = useState(descriptions);

  useEffect(() => {
    setLocalValue(descriptions);
  },[])

  // Sync prop to local on mount or change
  useEffect(() => {
    if (descriptions !== localValue) {
      setLocalValue(descriptions);
    }
  }, [descriptions]);

  // Debounced function to emit changes to parent
  const debouncedUpdate = useCallback(
    debounce((value) => {
      if (value !== descriptions) {
        onChange(value);
      }
    }, 400),
    [descriptions, onChange]
  );

  const handleChange = (html) => {
    setLocalValue(html);
    debouncedUpdate(html);
  };

  const closeModal = () => setDescriptionModal(false);

  return (
    <>
      <div className="product-description">
        {!descriptionModal && <ReactQuill
          value={localValue}
          modules={modules}
          placeholder="Enter product description here.."
          onChange={handleChange}
        />}
        <FontAwesomeIcon
          icon={faUpRightAndDownLeftFromCenter}
          className="icon-arrow"
          onClick={() => setDescriptionModal(true)}
        />
      </div>

      <Modal
        isOpen={descriptionModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Product Description Modal"
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="product-description__modal-header">
          <H3Text text="Product Description" />
          <FontAwesomeIcon icon={faClose} onClick={closeModal} />
        </div>
        <div>
          <ReactQuill
            value={localValue}
            placeholder="Product description here.."
            onChange={handleChange}
            modules={modules}
          />
        </div>
      </Modal>
    </>
  );
};

export default ProductDescriptions;
